export default function isRegex(str, regex){
  if (str.match(regex)) {
    return true;
  } else {
    return false;
  }
}
